export default __webpack_public_path__ + "static/media/Microcef-400-eng.4e937441.jpg";